import {isNil } from 'ramda';

export const stripHtml = (html) =>  {
  let doc = new DOMParser().parseFromString(html, 'text/html');
  return isNil(html) ? "" : doc.body.textContent || "";
}
